<template>
    <v-card-text class="px-3">
        <div class="text-center">
            <v-img
                src="/images/payment-logos/worldremit.png"
                contain
                class="align-self-start mx-auto mb-3"
                height="50"
            />

            <h4 class="title primary--text mb-5" style="line-height: 1.25;">
                Kaoshi Network App uses RemDat to create your
                <span class="font-weight-bold">WorldRemit</span>
                Account.
            </h4>
        </div>

        <div class="mb-3">
            <div class="d-flex">
                <v-icon
                    color="primary"
                    class="mr-3"
                    style="height: 35px"
                >
                    mdi-check
                </v-icon>
                <p class="title primary--text my-0">
                    Secure
                </p>
            </div>
            <p class="subtitle-1 my-0 ml-9" style="line-height: 1.5;">
                Encryption helps protect your personal financial data
            </p>
        </div>

        <div class="mb-3">
            <div class="d-flex">
                <v-icon
                    color="primary"
                    class="mr-3"
                    style="height: 35px"
                >
                    mdi-check
                </v-icon>
                <p class="title primary--text my-0">
                    Private
                </p>
            </div>
            <p class="subtitle-1 my-0 ml-9" style="line-height: 1.5;">
                Kaoshi is not in possession of your login credentials.
                Your login credentials are locally encrypted and decrypted
                by the sticky note extension locally installed on your computer
            </p>
        </div>

        <div
            class="text-center subtitle-2"
        >
            By selecting "Proceed", you agree to the
            <a
                href="javascript:void(0)"
                class="font-weight-bold text-decoration-underline"
                @click="openTermsOfService"
            >
                WorldRemit Terms and Conditions
            </a> and
            <a
                v-if="privacyPolicyUrl"
                href="javascript:void(0)"
                class="font-weight-bold text-decoration-underline"
                @click="openPrivacyPolicy"
            >
                WorldRemit User Privacy Policy
            </a>
        </div>

        <div class="text-center my-4">
            <v-btn
                class="text--white text-capitalize py-5 title mt-2"
                color="primary"
                depressed
                large
                block
                elevation="2"
                @click="proceed"
                :disabled="!canProceed"
            >
                Proceed
            </v-btn>
        </div>

        <div class="text-right">
            <v-btn
                text
                class="font-weight-bold primary--text text-none subtitle-1"
                @click="$emit('manuallyCreateAccount')"
            >
                Want to do this yourself? Sign Up Manually
            </v-btn>
        </div>
    </v-card-text>
</template>

<script>
export default {
    data() {
        return {
            termsOfServiceUrl: 'https://www.worldremit.com/en/about-us/terms-and-conditions',
            privacyPolicyUrl: 'https://www.worldremit.com/en/about-us/privacy-policy',
            termsOfServiceRead: false,
            privacyPolicyRead: false,
        };
    },
    mounted() {
        this.termsOfServiceRead = false;
        this.privacyPolicyRead = false;
    },
    computed: {
      canProceed() {
          return this.termsOfServiceRead && this.privacyPolicyRead;
      },
    },
    methods: {
        openTermsOfService() {
            this.termsOfServiceRead = true;
            window.open(this.termsOfServiceUrl, '_blank');
        },
        openPrivacyPolicy() {
            this.privacyPolicyRead = true;
            window.open(this.privacyPolicyUrl, '_blank');
        },
        async proceed() {
            if (!this.canProceed) {
                return;
            }

            this.$emit('proceed');
        },
    },
};
</script>
